import { Requests } from "../common/request.common";
import { DevResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const devtools = {
    syncIndexes() {
        return postEmpty("/dev/sync-indexes");
    },
    syncAttSessionRawAtt() {
        return postEmpty("/dev/sync-att-session");
    },
    syncScheduleRuleM() {
        return postEmpty("/dev/sync-schedule-rule-m");
    },
    syncScheduleRuleOutOnTime() {
        return postEmpty("/dev/sync-schedule-rule-out-on-time");
    },
    syncTimeTableOnSchoolAgency() {
        return postEmpty("/dev/sync-schedule-time-table-on-school-agency");
    },
    syncAttSubmission() {
        return postEmpty("/dev/sync-att-submission");
    },
    syncUserAttPhone() {
        return postEmpty("/dev/sync-user-att-phone");
    },
    removeUserAttPhoneAlt() {
        return postEmpty("/dev/remove-user-att-phone-alt");
    },
    syncAttSubmissionReviewer() {
        return postEmpty("/dev/sync-att-submission-reviewer");
    },
    obtainMobile() {
        return get<DevResponseTypes.ObtainMobile>("/dev/obtain/mobile");
    },
    obtainMaintenance() {
        return get<DevResponseTypes.ObtainMaintenance>("/dev/obtain/maintenance");
    },
    updateMobile(data: typeof Requests.Dev.MobileSettings.Input) {
        return post<typeof data>("/dev/update/mobile", data);
    },
    updateMobileErrorLog(data: typeof Requests.Dev.MobileErrorLogEnabled.Input) {
        return post<typeof data>("/dev/update/mobile-error-log", data);
    },
};
